module.exports = __webpack_public_path__ + "static/media/edit-pencil.2d01aaf6.svg";